import { c as _c } from "react/compiler-runtime";
import { getStarVariants, TrustpilotStar } from "@/components/custom/ProductBuilder/TrustpilotStar";
import { getRatingLabel } from "@/lib/trustpilot/ratingLabel";
interface Props {
  ratingAverage?: number;
  ratingCount?: number;
}
export function PlpProductCardRating(t0) {
  const $ = _c(17);
  const {
    ratingAverage,
    ratingCount
  } = t0;
  if (!ratingAverage || !ratingCount) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== ratingAverage) {
    const starVariants = getStarVariants(ratingAverage, 5);
    t3 = "flex items-center gap-3";
    t4 = "plp-product-card-rating";
    t1 = "flex items-center gap-0.5";
    t2 = starVariants.map(_temp);
    $[0] = ratingAverage;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ratingAverage) {
    t6 = getRatingLabel(ratingAverage);
    $[8] = ratingAverage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="text-xs leading-none font-semibold text-muted-foreground">{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t3} data-testid={t4}>{t5}{t7}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(variant, index) {
  return <TrustpilotStar key={`plp-trust-star-${index}-${variant}`} variant={variant} className="h-5 w-5" />;
}